import { useRef } from "react";
import { useSidebarPanel } from "./useSidebarPanel";
import { useSidebarShallowStore } from "../../store/sidebar-store";
import { cn } from "@tellescope/design-system";
import { ContactDetailsSidebar } from "./ContactDetailsSidebar";

export const SidebarPanel = () => {
  const panelRef = useRef<HTMLElement>(null);
  const { contentType, contentTypeData } = useSidebarShallowStore("contentType", "contentTypeData");
  const { isOpen, width, onDragStart, toggleIsOpen, setViewId } = useSidebarPanel(panelRef);

  return (
    <aside
      ref={panelRef}
      className={cn(
        "relative border-l border-l-gray-200 h-svh transition-[width] flex-shrink-0 overflow-hidden flex flex-col bg-background",
        isOpen ? "" : "w-0 overflow-hidden"
      )}
      style={isOpen ? { width } : undefined}
    >
      {isOpen && (
        <div
          className="absolute left-0 top-0 z-10 h-full w-1 cursor-col-resize flex items-center justify-center"
          onMouseDown={onDragStart}
        >
          <div className="w-0.5 h-10 rounded-full bg-gray-200 hover:bg-blue-400/50 active:bg-blue-400/70 transition-colors" />
        </div>
      )}
      <div className="h-svh flex flex-col gap-0" data-testid={isOpen ? "contact-details-sidebar" : undefined}>
        {isOpen && contentType === "ContactDetails" && contentTypeData.ContactDetails?.enduserId && (
          <ContactDetailsSidebar
            enduserId={contentTypeData.ContactDetails?.enduserId}
            viewId={contentTypeData.ContactDetails.selectedViewId}
            setViewId={setViewId}
            closeSidebar={toggleIsOpen}
          />
        )}
      </div>
    </aside>
  );
};
